import React from 'react';
import { createUseStyles } from 'react-jss';

import { type StsIconName, Icon, Typography } from '@packages/ui/shared';

const PREVIEW_UNSUPPORTED_MESSAGE = 'Preview not available.\nDownload to view the file.';

const useStyles = createUseStyles({
    container: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
});

export interface UnsupportedViewerProps {
    fileName: string;
    contentType?: string;
}

export function UnsupportedViewer({ fileName, contentType }: UnsupportedViewerProps) {
    const classes = useStyles();
    const iconName = resolveIconName(contentType);

    return (
        <div className={classes.container} data-testid="unsupported-viewer">
            <Icon name={iconName} color="white" size={90} />

            <Typography variant="lead" color="white" style={{ marginBottom: 8 }}>
                {fileName}
            </Typography>
            <Typography variant="lead" color="white">
                {PREVIEW_UNSUPPORTED_MESSAGE}
            </Typography>
        </div>
    );
}

function resolveIconName(contentType?: string | undefined): StsIconName {
    if (!contentType) {
        return 'file';
    }

    if (contentType.startsWith('image/')) {
        return 'image';
    }

    if (contentType.startsWith('video/')) {
        return 'videocam';
    }

    return 'file';
}
